import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";
import { cancel } from "../../../services/membership";
import { toast } from "react-toastify";
class CancelModel extends Component {
    state = {
        isLoading: false,
    };


    cancel = () => {
        this.setState({
            isLoading: true,
        });
        cancel(this.props.id)
            .then(res => { 
                //this.context.state.updateUser();
                this.props.hideAll();  
                this.setState({
                    isLoading: false,
                });
                toast.success(res.message);
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                });
                this.context.state.handelError(error);
            });
    };

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
			<button onClick={this.props.hideAll} type="button" className="modal-close" data-dismiss="modal" aria-hidden="true"><img src="/images/close.svg" alt="close"/></button>
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header mt-0 mb-3">
                        <img src="/images/cancelMembership.png" alt=""></img>
                    </div>
                    <h2 className="model-title text-center mb-3" id="model-title">
                        Cancel ProWriter Membership
                    </h2>
                    <div className="model-content">
                        <div
                            id="model-content"
                            className=" text-center model-html-container"
                        >
                            Are you sure you want to cancel your membership ?
                        </div>
                        <div
                            className="model-validation-message"
                            id="model-validation-message"
                        ></div>
                    </div>
                    <div className="model-actions">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={this.cancel}
                            disabled={this.state.isLoading}
                        >
                            Cancel Membership &nbsp;&nbsp;
                            {this.state.isLoading === true ? <i class="fa fa-spinner fa-spin btn__loader" aria-hidden="true"></i> : ''}
                            
                        </button>
                        <button
                            type="button"
                            onClick={this.props.hideAll}
                            className="btn btn-primary"
                        >
                            Nevermind
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
CancelModel.contextType = AppContext;
export default CancelModel;



// WEBPACK FOOTER //
// ./src/components/writer/billing/CancelModel.js